// Get current datetime in YYYY-MM-DDTHH:mm format (for datetime-local input)
export const getCurrentDatetimeLocal = (): string => {
    const date = new Date()
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

// Convert YYYY-MM-DDTHH:mm → mm/dd/yyyy HH:mm (for API)
export const covnertToDateTimeFormat = (value: string): string => {
    if (!value) return ''
    const [datePart, timePart] = value.split('T')
    const [year, month, day] = datePart.split('-')
    return `${month}/${day}/${year} ${timePart}`
}
